const resources = {
  "en": {
    "personalCircle": {
      "title": "Personal circle",
      "description": "Keep a simple view of the people around you and move them between relationship layers when things change.",
      "addCardTitle": "Add contact",
      "addCardDescription": "Start a new contact with the layer that feels right today. You can move them later any time.",
      "layersSectionTitle": "Your relationship layers",
      "layersSectionDescription": "{{total}} contacts currently grouped across {{groups}} active layers.",
      "layerCount": "{{count}} contacts",
      "form": {
        "nameLabel": "Name",
        "layerLabel": "Layer",
        "namePlaceholder": "Name",
        "nameRequired": "Enter a name",
        "addButton": "Add"
      },
      "list": {
        "empty": "No contacts"
      },
      "confirm": {
        "delete": "Delete?"
      },
      "notifications": {
        "loadError": "Failed to load contacts"
      },
      "layers": {
        "veryClose": "Very close",
        "close": "Close circle",
        "acquaintance": "Acquaintances",
        "clients": "Clients",
        "subscribers": "Subscribers",
        "strangers": "Strangers"
      }
    }
  },
  "uk": {
    "personalCircle": {
      "title": "Особисте коло",
      "description": "Тримайте простий список людей навколо вас і переносіть їх між шарами стосунків, коли це змінюється.",
      "addCardTitle": "Додати контакт",
      "addCardDescription": "Додайте новий контакт у шар, який зараз найбільше підходить. За потреби ви зможете змінити його пізніше.",
      "layersSectionTitle": "Ваші шари стосунків",
      "layersSectionDescription": "{{total}} контактів зараз розподілено між {{groups}} активними шарами.",
      "layerCount": "{{count}} контактів",
      "form": {
        "nameLabel": "Ім’я",
        "layerLabel": "Шар",
        "namePlaceholder": "Ім'я",
        "nameRequired": "Введіть ім’я",
        "addButton": "Додати"
      },
      "list": {
        "empty": "Немає контактів"
      },
      "confirm": {
        "delete": "Видалити?"
      },
      "notifications": {
        "loadError": "Не вдалося завантажити контакти"
      },
      "layers": {
        "veryClose": "Дуже близькі",
        "close": "Близьке коло",
        "acquaintance": "Знайомі",
        "clients": "Клієнти",
        "subscribers": "Підписники",
        "strangers": "Незнайомці"
      }
    }
  }
};

export default resources;
